<script setup>
import { ref } from 'vue'

const expired = ref(false)

function setExpired(value) {
    expired.value = value
}
</script>

<template>
    <slot
        v-bind="{ expired, setExpired }"
        name="default"
    />
</template>
